'use strict';

module.exports = {
  UNSUPPORTED_BUCKET_METHOD: 'MalformedXML'
};